var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGastriointestinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50977 6.30046L4.55981 5.80046C6.56981 4.85046 8.86978 4.74046 10.9598 5.50046C10.9598 5.50046 12.3098 6.13046 12.7998 6.17046C13.0498 6.19046 13.7998 5.96046 13.7998 5.96046C15.4698 5.62046 18.2998 5.58046 19.4498 7.04046C21.9098 10.1605 20.4198 12.8005 20.4198 12.8105C19.1398 16.0305 18.9398 15.3805 18.9398 15.7005",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5104 15.64L17.0904 15.08L18.1904 12.2L15.5704 13.98L14.3104 12.81L16.8304 10.75C17.2304 10.31 17.2304 9.65004 16.8304 9.21004V9.26004C16.2004 8.51004 14.8904 8.62004 13.9904 8.81004C13.3304 8.95004 12.6404 8.93004 12.0004 8.72004L11.0504 8.41004C9.48041 7.75004 7.74039 7.63004 6.09039 8.04004C5.82039 8.11004 5.56042 8.21004 5.31042 8.33004L4.40039 8.75004",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.93 15.7006C18.93 15.7006 18.89 17.8406 16.55 18.4906C16.55 18.4906 11.97 19.5006 8.72998 17.9106C8.72998 17.9106 7.44995 17.3606 6.69995 16.5406C6.26995 15.8706 5.59001 15.4006 4.82001 15.2406L3 14.8506",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74023 12.1604L6.40021 12.8004L7.07025 12.4204C7.66025 12.0804 8.29025 11.8104 8.94025 11.6104C11.1002 10.9504 13.3902 10.8604 15.5902 11.3604",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9297 16.39L12.0997 16.49C12.8197 16.89 13.6597 16.82 14.3197 16.29L14.6797 16",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05078 14.6109L9.22076 14.4809C9.80076 14.0109 10.4808 13.8109 11.1508 13.9009L11.5708 13.9609",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGastriointestinal);
export default __webpack_public_path__ + "static/media/Gastriointestinal.60637578f757f27cf42baf3911560f8b.svg";
export { ForwardRef as ReactComponent };